module.exports = __webpack_public_path__ + "img/sended.094736df.png";